import React from 'react';
import classNames from 'classnames';

const PopUp = ({headline, large, label, active, onClose}) => (
    <div className={classNames('region-image', 'toggle-map', {active})}>
        <a className="back" onClick={onClose}>
            <i className="icon icon-close" />
        </a>
        <div className="toggle-map-detail">
            <p className="backlink">
                <a href={large}>{headline}</a>
            </p>
            <img src={large} alt={label} />
        </div>
    </div>
);

export default PopUp;
